'use strict';exports.__esModule = true;var styleTab = exports.styleTab = {
  padding: '10px 10px',
  display: 'inline-flex',
  cursor: 'pointer',
  color: '#231F20',
  textAlign: 'center',
  fontSize: '18px',
  justifyContent: 'center',
  alignItems: 'center',
  fontWeight: '600' };


var styleActiveTab = exports.styleActiveTab = Object.assign({},
styleTab, {
  background: 'inherit',
  borderBottom: 'solid #04AAEB 2px' });


//////////////////
// WEBPACK FOOTER
// ./src/containers/AuthenticationContainer/AuthTab/constants.js
// module id = 2922
// module chunks = 0